import {
  MaterialCategoryName,
  MaterialGroup,
  MaterialUnit,
} from "fe-shared/src/types/domain";

import { TransactionMaterial } from "../types";

const defaultCategories: MaterialCategoryName[] = [
  MaterialCategoryName.Tires,
  MaterialCategoryName.Products,
];

const getMaterialGroups = (
  currentMaterials: TransactionMaterial[],
  categories = defaultCategories
) => {
  const getMaterialsGroup = (
    materialCategoryName: MaterialCategoryName
  ): MaterialGroup<TransactionMaterial> => {
    const items = currentMaterials.filter(
      (m) =>
        m.materialCategoryName === materialCategoryName && m.units.unitQuantity
    );

    return {
      items,
      materialCategoryName,
      unit: items[0]?.units.unit || MaterialUnit.Kg,
    };
  };

  return categories
    .map((category) => getMaterialsGroup(category))
    .filter((g) => g.items.length);
};

export default getMaterialGroups;
